export const FETCH_ALERTS = 'FETCH_ALERTS';
export const FETCH_ALERTS_SUCCESS = 'FETCH_ALERTS_SUCCESS';
export const FETCH_ALERTS_FAIL = 'FETCH_ALERTS_FAIL';
export const CHANGE_ALERT_LIST_PAGE = 'CHANGE_ALERT_LIST_PAGE';
export const UPDATE_ALERT_LIST_FILTERS = 'UPDATE_ALERT_LIST_FILTERS';
export const SELECT_ALERTS_ID = 'SELECT_ALERTS_ID';
export const SELECT_ALERTS = 'SELECT_ALERTS';
export const RELOAD_ALERTS = 'RELOAD_ALERTS';
export const FETCH_TYPOLOGIES = 'FETCH_TYPOLOGIES';
export const FETCH_TYPOLOGIES_SUCCESS = 'FETCH_TYPOLOGIES_SUCCESS';
export const FETCH_TYPOLOGIES_FAIL = 'FETCH_TYPOLOGIES_FAIL';
export const CHANGE_ALERT_LIST_PAGE_SIZE = 'CHANGE_ALERT_LIST_PAGE_SIZE';
export const FETCH_SOURCES = 'FETCH_SOURCES';
export const FETCH_SOURCES_SUCCESS = 'FETCH_SOURCES_SUCCESS';
export const FETCH_SOURCES_FAIL = 'FETCH_SOURCES_FAIL';
export const FETCH_ALERT_RETRY_HISTORY_LIST = 'FETCH_ALERT_RETRY_HISTORY_LIST';
export const FETCH_ALERT_RETRY_HISTORY_LIST_SUCCESS =
  'FETCH_ALERT_RETRY_HISTORY_LIST_SUCCESS';
export const FETCH_ALERT_RETRY_HISTORY_LIST_FAIL =
  'FETCH_ALERT_RETRY_HISTORY_LIST_FAIL';

export const updateAlertListFilters = (filters) => ({
  type: UPDATE_ALERT_LIST_FILTERS,
  payload: filters
});

export const fetchAlerts = ({ filters, currentPage, pageSize }) => ({
  type: FETCH_ALERTS,
  payload: { filters, currentPage, pageSize }
});

export const fetchAlertsSuccess = ({ alerts, total }) => ({
  type: FETCH_ALERTS_SUCCESS,
  payload: { alerts, total }
});

export const fetchAlertsFail = () => ({
  type: FETCH_ALERTS_FAIL
});

export const changeAlertListPage = (currentPage) => ({
  type: CHANGE_ALERT_LIST_PAGE,
  payload: currentPage
});

export const selectAlertsId = (selectedIds) => ({
  type: SELECT_ALERTS_ID,
  payload: selectedIds
});

export const selectAlerts = (selectedAlerts) => ({
  type: SELECT_ALERTS,
  payload: selectedAlerts
});

export const reloadAlerts = () => ({
  type: RELOAD_ALERTS
});

export const fetchTypologies = () => ({
  type: FETCH_TYPOLOGIES
});

export const fetchTypologiesSuccess = (typologies) => ({
  type: FETCH_TYPOLOGIES_SUCCESS,
  payload: typologies
});

export const fetchTypologiesFail = () => ({
  type: FETCH_TYPOLOGIES_FAIL
});

export const changeAlertListPageSize = (pageSize) => ({
  type: CHANGE_ALERT_LIST_PAGE_SIZE,
  payload: pageSize
});

export const fetchSources = () => ({
  type: FETCH_SOURCES
});

export const fetchSourcesSuccess = (sources) => ({
  type: FETCH_SOURCES_SUCCESS,
  payload: sources
});

export const fetchSourcesFail = () => ({
  type: FETCH_SOURCES_FAIL
});

export const fetchAlertRetryHistoryList = (payload) => ({
  type: FETCH_ALERT_RETRY_HISTORY_LIST,
  payload
});

export const fetchAlertRetryHistoryListSuccess = (typologies) => ({
  type: FETCH_ALERT_RETRY_HISTORY_LIST_SUCCESS,
  payload: typologies
});

export const fetchAlertRetryHistoryListFail = () => ({
  type: FETCH_ALERT_RETRY_HISTORY_LIST_FAIL
});
